import { combineReducers } from "redux";

import adminSession from "./adminSession";
import assessmentSession from "./assessmentSession";
import botpressSession from "./botpressSession";
import creatorSession from "./creatorSession";
import onboardingSession from "./onboardingSession";
import partnerSession from "./partnerSession";
import patientSession from "./patientSession";
import providerSession from "./providerSession";
import userSession from "./userSession";

export default combineReducers({
  onboardingSession,
  userSession,
  patientSession,
  adminSession,
  assessmentSession,
  partnerSession,
  providerSession,
  creatorSession,
  botpressSession,
});
